import type { TourDocumentDataDto } from 'shared/api/tours/document-data'

import { TourDocumentView } from './types'

const parseAmount = (value: string | null) => {
  if (value === null) return null

  const amount = Number(value)

  return Number.isFinite(amount) ? amount : null
}

const parseStars = (value: string | null) => {
  if (value === null) return null

  const stars = Number(value)

  return Number.isFinite(stars) ? stars : null
}

export const mapDocumentData = (
  data: TourDocumentDataDto,
): TourDocumentView => ({
  id: data.id,
  documentNumber: data.document_number,
  documentUrl: data.document_url,
  signedAt: data.signed_at,
  additionalDocumentUrl: data.additional_document_url,
  additionalSignedAt: data.additional_signed_at,
  isOnlineSign: data.is_online_sign,
  status: data.status,
  paymentStatus: data.payment_status,
  paymentType: data.payment_type,
  expire: data.expire,
  fullPaymentBeforeDate: data.full_payment_before_date,
  amount: parseAmount(data.amount),
  remainingAmount: parseAmount(data.remaining_amount),
  remainingAmountRaw: data.remaining_amount,
  currency: data.currency,
  title: data.tour_name,
  startDate: data.start_date,
  endDate: data.end_date,
  nights: data.nights,
  hotel: data.hotel,
  stars: parseStars(data.stars),
  cover: data.cover,
  description: data.tour_additional_info,
  manager: {
    name: data.responsive_full_name,
    email: data.responsive_email,
    phone: data.responsive_phone_number,
    whatsappUrl: data.responsive_whatsapp_url,
    telegramUrl: data.responsive_telegram_url,
  },
  passengers: data.passengers.map((passenger) => ({
    id: passenger.id,
    fullName: passenger.full_name,
    isCurrentUser: passenger.is_current_user,
    isCustomer: passenger.is_customer,
  })),
  payments: data.payments.map((payment) => ({
    id: payment.id,
    amount: parseAmount(payment.amount),
    kind: payment.kind,
    paymentMethod: payment.payment_method,
    status: payment.status,
    transactionId: payment.transaction_id,
    paymentDate: payment.payment_date,
  })),
  canPay: data.can_pay,
})

export const getPaidAmount = (document: TourDocumentView) => {
  if (document.amount === null || document.remainingAmount === null) {
    return null
  }

  return Math.max(0, document.amount - document.remainingAmount)
}
